module.exports = __webpack_public_path__ + "img/bank.010db66c.png";